import { type FC, useId } from 'react';

import { theme } from '../../theme';
import { Radio } from '../Radio';
import Typography from '../Typography';
import { StyledCopy, StyledMarkSlot, StyledRoot } from './RadioCard.styled';
import type { RadioCardProps } from './types';

const RadioCard: FC<RadioCardProps> = ({
  value,
  label,
  description,
  disabled,
  size = 'md',
  variant = 'outline',
  className,
}) => {
  const labelId = useId();
  const descriptionId = useId();

  return (
    <StyledRoot className={className} $size={size} $variant={variant} $mark="radio">
      <StyledMarkSlot $size={size}>
        <Radio
          value={value}
          disabled={disabled}
          size={size === 'md' ? 'sm' : 'md'}
          aria-labelledby={labelId}
          aria-describedby={description ? descriptionId : undefined}
        />
      </StyledMarkSlot>

      <StyledCopy>
        <Typography
          as="span"
          id={labelId}
          variant="body3"
          fontWeight={600}
          color={theme.colors.text.primary}
        >
          {label}
        </Typography>
        {description && (
          <Typography
            as="span"
            id={descriptionId}
            variant="body4"
            color={theme.colors.text.secondary}
          >
            {description}
          </Typography>
        )}
      </StyledCopy>
    </StyledRoot>
  );
};

RadioCard.displayName = 'RadioCard';

export default RadioCard;
